import Input from "@components/ui/Input";

function StatusPill({ enabled }) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
        enabled ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-700"
      }`}
    >
      {enabled ? "Enabled" : "Disabled"}
    </span>
  );
}

function Toggle({ enabled, onToggle }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`relative inline-flex h-5 w-9 flex-shrink-0 items-center rounded-full transition ${
        enabled ? "bg-green-600" : "bg-gray-300"
      }`}
      aria-label="Toggle UniFi scraping"
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${
          enabled ? "translate-x-4" : "translate-x-0.5"
        }`}
      />
    </button>
  );
}

export default function UnifiEditor({ enabled, consoleId, onChange }) {
  return (
    <div className="border rounded-lg p-4 bg-white space-y-3">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="text-sm font-semibold flex items-center gap-2">
            UniFi Talk PBX
            <StatusPill enabled={!!enabled} />
          </div>
          <div className="text-xs text-gray-600 mt-1">
            Toggle scraping and set the UniFi console identifier for this
            clinic.
          </div>
        </div>
        <Toggle enabled={!!enabled} onToggle={() => onChange("enabled", !enabled)} />
      </div>

      <Input
        label="UniFi Console ID"
        value={consoleId ?? ""}
        onChange={(e) => onChange("consoleId", e.target.value)}
        placeholder="e.g. udm-pro-01 / console UUID / hostname"
        disabled={!enabled}
      />
    </div>
  );
}
